/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Tabs, Input, Typography, Radio } from 'antd';
import MaterialConsumptionSection from '../components/DSR/MaterialConsumptionSection';
import ProductionJointsSection from '../components/DSR/ProductionJointsSection';
import EquipmentUsageSection from '../components/DSR/EquipmentUsageSection';
import EHSSection from '../components/DSR/EHSSection';
import TechnicianLogSection from '../components/DSR/TechnicianLogSection';
import DownTimeSection from '../components/DSR/DownTimeSection';
import ConsumablesSection from '../components/DSR/ConsumablesSection';
import { connect } from 'react-redux';
import { get } from 'lodash';
import {
  fetchMaterialLog,
  updateMaterialLog,
  fetchProductionLog,
  updateProductionLog,
  fetchEquipmentUsageLog,
  updateEquipmentUsageLog,
  fetchEhsLog,
  updateEhsLog,
  fetchDowntimeLog,
  updateDowntimeLog,
  fetchConsumablesLog,
  updateConsumablesLog,
  fetchTechnicianLog,
  updateTechnicianLog,
  updateDsrLogSections,
} from '../redux/dsr/action';

const { TabPane } = Tabs;

const DSRTabList = (props) => {
  const {
    selectedProject,
    selectedData,
    isFetchingDsrMaterialConsumption,
    dsrMaterialConsumption,
    dsrSowId,
    productionJointsList,
    sowDetails,
  } = props;

  const { Text } = Typography;

  // Find the selectedMainline from sowDetails
  const selectedMainline = sowDetails?.find((s) => s.id === dsrSowId) || {};
  const selectedDate = selectedData?.logDate ? new Date(selectedData.logDate) : new Date();
  const [activeShift, setActiveShift] = useState('day');

  return (
    <div>
      <div style={{ marginBottom: 16, padding: '8px 16px' }}>
        <Radio.Group
          value={activeShift}
          onChange={(e) => setActiveShift(e.target.value)}
          buttonStyle="solid"
        >
          <Radio.Button value="day">Day Shift</Radio.Button>
          <Radio.Button value="night">Night Shift</Radio.Button>
        </Radio.Group>
      </div>
      {selectedData.isSkipped != 1 ? (
        <Tabs className="custom-tab h-100" defaultActiveKey="1">
          <TabPane tab="Material Consumption" key="1" style={{ position: 'relative' }}>
            <MaterialConsumptionSection
              shift={activeShift}
              selectedDate={selectedDate}
              selectedProject={selectedProject}
              selectedMainline={selectedMainline}
              currentDsrLog={selectedData}
              isSkipped={false}
              isSubmitted={false}
              onComplete={() => {}}
              onCancel={() => {}}
            />
          </TabPane>
          <TabPane tab="Production joints" key="2" style={{ position: 'relative' }}>
            <ProductionJointsSection
              shift={activeShift}
              selectedDate={selectedDate}
              selectedProject={selectedProject}
              selectedMainline={selectedMainline}
              currentDsrLog={selectedData}
              isSkipped={false}
              isSubmitted={false}
              onComplete={() => {}}
              onCancel={() => {}}
            />
          </TabPane>
          <TabPane tab="Equipment usage" key="3" style={{ position: 'relative' }}>
            <EquipmentUsageSection
              shift={activeShift}
              selectedDate={selectedDate}
              selectedProject={selectedProject}
              selectedMainline={selectedMainline}
              currentDsrLog={selectedData}
              isSkipped={false}
              isSubmitted={false}
              onComplete={() => {}}
              onCancel={() => {}}
            />
          </TabPane>
          <TabPane tab="EHS Issues & Corrective Actions" key="4" style={{ position: 'relative' }}>
            <EHSSection
              shift={activeShift}
              selectedDate={selectedDate}
              selectedProject={selectedProject}
              selectedMainline={selectedMainline}
              currentDsrLog={selectedData}
              isSkipped={false}
              isSubmitted={false}
              onComplete={() => {}}
              onCancel={() => {}}
            />
          </TabPane>
          <TabPane tab="Down time" key="5" style={{ position: 'relative' }}>
            <DownTimeSection
              shift={activeShift}
              selectedDate={selectedDate}
              selectedProject={selectedProject}
              selectedMainline={selectedMainline}
              currentDsrLog={selectedData}
              isSkipped={false}
              isSubmitted={false}
              onComplete={() => {}}
              onCancel={() => {}}
            />
          </TabPane>
          <TabPane tab="Consumables & PPE Usage" key="6" style={{ position: 'relative' }}>
            <ConsumablesSection
              shift={activeShift}
              selectedDate={selectedDate}
              selectedProject={selectedProject}
              selectedMainline={selectedMainline}
              currentDsrLog={selectedData}
              isSkipped={false}
              isSubmitted={false}
              onComplete={() => {}}
              onCancel={() => {}}
            />
          </TabPane>
          <TabPane tab="Technician Log" key="7" style={{ position: 'relative' }}>
            <TechnicianLogSection
              shift={activeShift}
              selectedDate={selectedDate}
              selectedProject={selectedProject}
              selectedMainline={selectedMainline}
              currentDsrLog={selectedData}
              isSkipped={false}
              isSubmitted={false}
              onComplete={() => {}}
              onCancel={() => {}}
            />
          </TabPane>
        </Tabs>
      ) : (
        <div style={{ margin: '20px 0', display: 'grid' }}>
          <p style={{ display: 'inline-flex' }}>
            <Text style={{ color: '#EF314C', fontSize: 16, fontWeight: '600' }}>DSR Skipped</Text>
          </p>
        </div>
      )}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginLeft: '30px',
          marginRight: '30px',
        }}
      >
        {selectedData.managerSignatureS3Object &&
          selectedData.managerSignatureS3Object.objectUrl && (
            <div style={{ width: '100%', marginRight: '10px' }}>
              <Text>Manager Signature:</Text>
              <img
                src={selectedData.managerSignatureS3Object.objectUrl}
                alt="manager signature"
                style={{ width: '30%', height: '100px' }}
              />
            </div>
          )}
        {selectedData.clientSignatureS3Object && selectedData.clientSignatureS3Object.objectUrl && (
          <div style={{ width: '100%' }}>
            <Text>Client Signature:</Text>
            <img
              src={selectedData.clientSignatureS3Object.objectUrl}
              alt="client signature"
              style={{ width: '30%', height: '100px' }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ materialConsumptionReducer, productionJointsReducer, dsrReducer }) => {
  const dsrMaterialConsumption = get(materialConsumptionReducer, 'dsrMaterialConsumption', []);
  const productionJointsList = get(productionJointsReducer, 'productionJointsList', []);
  const isFetchingDsrMaterialConsumption = get(
    materialConsumptionReducer,
    'isFetchingDsrMaterialConsumption',
    false
  );
  const currentDsrLog = get(dsrReducer, 'currentDsrLog', null);
  const isUpdatingDsrLogSections = get(dsrReducer, 'isUpdatingDsrLogSections', false);

  return {
    dsrMaterialConsumption,
    isFetchingDsrMaterialConsumption,
    productionJointsList,
    currentDsrLog,
    isUpdatingDsrLogSections,
  };
};

const mapDispatchToProps = {
  onFetchMaterialLog: fetchMaterialLog,
  onUpdateMaterialLog: updateMaterialLog,
  onFetchProductionLog: fetchProductionLog,
  onUpdateProductionLog: updateProductionLog,
  onFetchEquipmentUsageLog: fetchEquipmentUsageLog,
  onUpdateEquipmentUsageLog: updateEquipmentUsageLog,
  onFetchEhsLog: fetchEhsLog,
  onUpdateEhsLog: updateEhsLog,
  onFetchDowntimeLog: fetchDowntimeLog,
  onUpdateDowntimeLog: updateDowntimeLog,
  onFetchConsumablesLog: fetchConsumablesLog,
  onUpdateConsumablesLog: updateConsumablesLog,
  onFetchTechnicianLog: fetchTechnicianLog,
  onUpdateTechnicianLog: updateTechnicianLog,
  onUpdateDsrLogSections: updateDsrLogSections,
};

export default connect(mapStateToProps, mapDispatchToProps)(DSRTabList);
